import VistaReportes from "@/views/VistaReportes.vue";

const reportes = {
  path: "/app/reportes",
  name: "reportes",
  component: VistaReportes,
};

export default reportes;
